<template>
  <div>
    <form
      v-if="subSection == 'destination'"
      action="#"
      class="form-group col-12 col-w-full"
      @submit.prevent="sendAuth()"
    >
      <div class="form-group col-12 mb-4">
        <div class="form-group mb-4">
          <div class="d-flow">
            <h5>
              Selecione um método para recebimento. Este código expirará em 10
              minutos
            </h5>
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  :value="true"
                  id="mobile-method"
                  v-model="model.mobile"
                />
                <label class="form-check-label" for="mobile-method">SMS</label>
              </div>
            </div>
            <div class="col-9">
              <span>{{ getMobile }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  :value="false"
                  id="email-method"
                  v-model="model.mobile"
                />
                <label class="form-check-label" for="email-method">Email</label>
              </div>
            </div>
            <div class="col-9">
              <span>{{ getEmail }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters mb-2 mt-2">
        <div class="col-6">
          <WhiteLabel class="mb-4 col-w-full">
            <button type="button" @click="returnStep()" class="btn no-focus-effect btn-md w-100">
              Voltar
            </button>
          </WhiteLabel>
        </div>
        <div class="col-6">
          <WhiteLabel class="mb-4 col-w-full">
            <button type="submit" class="btn btn-md btn-orange w-100">
              Continuar
            </button>
          </WhiteLabel>
        </div>
      </div>
    </form>

    <form
      v-if="subSection == 'code'"
      action="#"
      class="form-group col-12 col-w-full"
      @submit.prevent="codeReady()"
    >
      <div class="form-group col-12 col-lg-9 mb-4">
        <input
          v-model="authCode"
          required
          type="text"
          class="form-control"
          placeholder="Código de verificação"
        />
        <small class="text-danger" v-if="!$v.authCode.minLength">
          O código deve ter 6 caracteres
        </small>
      </div>

      <p v-if="authCodeTimer > 0" class="col-12 col-w-full">
        Você poderá enviar um novo código em
        <b>{{ authCodeTimer }}</b> segundos...
      </p>
      <WhiteLabel class="mb-4">
        <a
          v-if="!(authCodeTimer > 0)"
          href="#"
          class="ml-auto mt-1 mr-4 col-12 col-w-full"
          @click.prevent="sendAuth()"
        >
          Enviar novo código
        </a>
      </WhiteLabel>

      <div class="row mb-3">
        <div class="col-6">
            <WhiteLabel>
                <button type="button" @click="returnStep()" class="btn btn-md col-12">
                    Voltar
                </button>
            </WhiteLabel>
        </div>
        <div class="col-6">
            <WhiteLabel>
                <button type="submit"
                    class="btn btn-md col-12 btn-orange">
                    Continuar
                </button>
            </WhiteLabel>
        </div>
    </div>
    </form>
  </div>
</template>

<script>
// component imports
import WhiteLabel from '@/components/shared/WhiteLabel';

// api imports
import AccountApi from '@/services/AccountApi';
import AuthCodeApi from '@/services/v2/AuthCodeApi';

// validation imports
import { minLength } from 'vuelidate/lib/validators';

export default {
  name: 'AuthCodeModalSection',

  components: {
    WhiteLabel,
  },

  props: {
    authCodeType: {
      type: String,
      required: false,
      default: 'pix-payment-order',
    },
    subSection: {
      type: String,
      required: true,
      default: 'destination',
    },
    mobile: {
      type: String,
      required: false,
      default: '',
    },
    email: {
      type: String,
      required: false,
      default: '',
    },
  },

  data: () => ({
    model: {
      type: 'pix-payment-order',
      mobile: true,
    },
    authCode: '',
    authCodeTimer: 20,
  }),

  mounted() {
    this.$bus.$on('cleanInput',(result) => {
         this.$emit('reset');
    });
  },

  computed: {
    getEmail() {
      if (!this.email) return '';

      var index = this.email.indexOf('@');
      var length = this.email.length;

      return `${this.email.substring(0, 2)}
        ${'*'.repeat(index - 2)}
        ${this.email.substring(index, length)}`;
    },
    getMobile() {
      if (!this.mobile) return '';
      return `${'*'.repeat(11)}${this.mobile.substring(10, 15)}`;
    },
  },

  watch: {
    authCodeTimer: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.authCodeTimer--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },

  methods: {
    async sendAuth() {
      if (this.$v.$invalid) {
        this.$alert.error('Ops', 'Confira o código!');
        return;
      }
      this.$bus.$emit('spinner-run');

      const api = new AuthCodeApi();
      this.model.type = this.authCodeType != null ? this.authCodeType :this.model.type;

      if (this.authCodeType === 'device-control') {
        const api = new AccountApi();
        let parameters = { splitterId: '', mobile: this.model.mobile };
        const result = await api.sendAuthCodeByType(parameters, this.authCodeType);
      } else {
        const result = await api.getAuthCode(this.model);
      }
      this.$emit('auth-sent', this.model.mobile);
      this.authCodeTimer = 30;
      this.$bus.$emit('spinner-stop');
    },

    codeReady() {
      this.$emit('code-ready', this.authCode);
    },

    returnStep() {
      this.$emit('return-step');
    },
  },

  validations: {
    authCode: {
      minLength: minLength(6),
    },
  },
};
</script>
